import PermissionList from '@/constants/permissions';
import statusesId from '@/constants/statusesId';

export default {
    data () {
        return {
            statusesId,
            PermissionList,
            permissions: {
                assignedFamilyEditionView: false,
                familyEditionView: false,
                specialistPackageCreate: false
            }
        };
    },
    computed: {
        family () {
            return this.$store.getters['family/getFamily'];
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        getResource () {
            return this.$store.getters['specialistPackage/getResource'];
        },
        getQuestions () {
            return this.$store.getters['specialistPackage/getQuestions'];
        },
        medicsPackagePermission () {
            if (
                this.permissions.assignedFamilyEditionView === false &&
        this.permissions.familyEditionView === false
            ) {
                return false;
            }
            if (this.family.medics_package == null) {
                return this.permissions.specialistPackageCreate;
            }

            return false;
        },
        lawyersPackagePermission () {
            if (
                this.permissions.assignedFamilyEditionView === false &&
        this.permissions.familyEditionView === false
            ) {
                return false;
            }
            if (this.family.lawyers_package == null) {
                return this.permissions.specialistPackageCreate;
            }

            return false;
        },
        statusCheck () {
            const statusId = this.family?.status?.family_edition_status_id || this.family?.status?.id;
            const preExclusionStatusId = this.family?.pre_exclusion_status?.family_edition_status_id;

            const allowedStatus = [
                this.statusesId.NOT_ATTRIBUTED,
                this.statusesId.CREATING_FIRST_SHEET,
                this.statusesId.STATUS_FINISHED_SUMMARY
            ];
            const allowedPreExclusionStatus = [
                this.statusesId.NOT_ATTRIBUTED,
                this.statusesId.CREATING_FIRST_SHEET
            ];

            if (this.statusesId.DISABLED === statusId) {
                return !allowedPreExclusionStatus.includes(preExclusionStatusId);
            }
            return !allowedStatus.includes(statusId);
        },
        canEditSpecialistPackage () {
            return this.statusCheck && this.isCurrentEdition === true;
        },
        readOnly () {
            if (this.canEditSpecialistPackage) {
                return !this.permissionsCheck;
            }
            return true;
        },
        isFormChanged () {
            return Object.keys(this.fields).some((key) => this.fields[key].changed);
        }
    },
    methods: {
        goBack () {
            this.$router.push({ name: 'family-card', params: { id: this.$route.params.familyId } });
        },
        clearBeforeLeave () {
            this.$store.dispatch('specialistPackage/clear');
        }
    },
    created () {
        window.addEventListener('beforeunload', (event) => {
            if (this.isFormChanged) {
                event.returnValue = window.confirm(this.$t('message.leave_confirmation'));
            }
        });
        this.$store
            .dispatch('auth/hasPermission', this.PermissionList.ASSIGNED_FAMILY_EDITION_VIEW)
            .then((data) => {
                this.permissions.assignedFamilyEditionView = data;
            });
        this.$store
            .dispatch('auth/hasPermission', this.PermissionList.FAMILY_EDITION_VIEW)
            .then((data) => {
                this.permissions.familyEditionView = data;
            });
        this.$store
            .dispatch('auth/hasPermission', this.PermissionList.SPECIALIST_PACKAGE_CREATE)
            .then((data) => {
                this.permissions.specialistPackageCreate = data;
            });
    },
    beforeRouteLeave (from, to, next) {
        if (this.isFormChanged && !this.$store.getters['token/isForcedToLogout']) {
            this.$refs.confirm.dialog = true;
            this.$refs.confirm.open().then((confirm) => {
                if (confirm) {
                    next();
                    this.clearBeforeLeave();
                } else {
                    next(false);
                }
            });
        } else {
            next();
            this.clearBeforeLeave();
        }
    }
};
